import { Settings, SocialEmail, SocialEmailsubscribed, User } from "@similarweb/icons";
import { Tooltip } from "@similarweb/ui-components";

import { colorsPalettes } from "@similarweb/styles";

import { TOOLTIP_DELAY, WORLDWIDE } from "app/pages/activation/components/HomeWithData/constants";
import { projectsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import {
    SETTINGS_TEXT,
    SUBSCRIBE_TOOLTIP,
    SUBSCRIBED_TOOLTIP,
} from "app/pages/activation/components/HomeWithData/texts";
import type { ActivationMetadataItem } from "app/pages/activation/types/api";

import * as SC from "./styles";

type ItemIconsSchema = {
    activation: ActivationMetadataItem;
    translate: (key: string) => string;
    countryObject: { text?: string } | undefined;
    onEmailClick: () => void;
    onRouteSubscriptions: () => void;
    onSettingsClick: () => void;
};

export const ItemIcons = ({
    activation,
    translate,
    countryObject,
    onEmailClick,
    onRouteSubscriptions,
    onSettingsClick,
}: ItemIconsSchema) => {
    const { isSubscribed, isOwn, sharedBy, country } = activation;

    return (
        <SC.IconsContainer data-automation={projectsDataAutomation.itemIcons}>
            {!isOwn ? (
                <Tooltip
                    content={sharedBy}
                    placement="bottom"
                    delay={TOOLTIP_DELAY}
                >
                    <User size="xs" />
                </Tooltip>
            ) : null}

            <Tooltip
                enabled={!!countryObject?.text}
                content={countryObject?.text}
                placement="bottom"
                delay={TOOLTIP_DELAY}
            >
                <SC.StyledCountryIcon
                    $isWorldWide={country === WORLDWIDE}
                    countryCode={country}
                    size="xs"
                />
            </Tooltip>

            <SC.Splitter />

            {isSubscribed ? (
                <Tooltip
                    content={translate(SUBSCRIBED_TOOLTIP)}
                    placement="bottom"
                    delay={TOOLTIP_DELAY}
                >
                    <SC.IconButton
                        data-automation={projectsDataAutomation.itemIconButton}
                        onClick={onRouteSubscriptions}
                    >
                        <SocialEmailsubscribed
                            size="xs"
                            color={colorsPalettes.carbon[0]}
                        />
                    </SC.IconButton>
                </Tooltip>
            ) : (
                <Tooltip
                    content={translate(SUBSCRIBE_TOOLTIP)}
                    placement="bottom"
                    delay={TOOLTIP_DELAY}
                >
                    <SC.IconButton
                        data-automation={projectsDataAutomation.itemIconButton}
                        onClick={onEmailClick}
                    >
                        <SocialEmail
                            size="xs"
                            color={colorsPalettes.carbon[0]}
                        />
                    </SC.IconButton>
                </Tooltip>
            )}

            <Tooltip
                content={translate(SETTINGS_TEXT)}
                placement="bottom"
                delay={TOOLTIP_DELAY}
            >
                <SC.IconButton
                    data-automation={projectsDataAutomation.itemIconButton}
                    onClick={onSettingsClick}
                >
                    <Settings
                        size="xs"
                        color={colorsPalettes.carbon[0]}
                    />
                </SC.IconButton>
            </Tooltip>
        </SC.IconsContainer>
    );
};
